
export interface ITypeGrantedDescriptor {
   curationType: string;
   source: string[];
}

export interface IGrantedAction {
   action: string;
   roles: string[];
   types: ITypeGrantedDescriptor[];
   userIsPermittedForAction?: boolean;
   worklistIsFullyPermitted?: boolean;
}

export interface IGrantedActionsTable {
   actionsTable: IGrantedAction[];
}

export interface IMultipleKbData {
   grantedKnowledgeBase: string;
   grantedActionsTable: IGrantedAction[];
}


